import * as i0 from "@angular/core";
export class Logger {
}
export class LoggerService {
    invokeConsoleMethod(type, args) { }
}
LoggerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoggerService_Factory() { return new LoggerService(); }, token: LoggerService, providedIn: "root" });
